import React from 'react';
import MypagAsListContainer from 'containers/MypagAsListContainer/MypagAsListContainer';

export default function MypagAsListPage() {
    return (
        <MypagAsListContainer />
    )
}
